import { createPortal } from 'react-dom'
import { CheckCircle2, Info, XCircle } from 'lucide-react'
import { useUI } from '../../store/ui'
import { cn } from '../../lib/cn'

const ICONOS = {
  exito: CheckCircle2,
  error: XCircle,
  info: Info,
}

const TONOS = {
  exito: 'text-lima-400',
  error: 'text-rojo-400',
  info: 'text-tinta-200',
}

/** Los avisos aparecen arriba en teléfono (donde está el pulgar no
 *  tapa nada) y abajo a la derecha en escritorio. */
export function Avisos() {
  const { avisos, cerrarAviso } = useUI()
  if (!avisos.length) return null

  return createPortal(
    <div className="pointer-events-none fixed inset-x-0 top-0 z-[60] flex flex-col items-center gap-2 p-4 safe-top sm:inset-x-auto sm:top-auto sm:right-6 sm:bottom-6 sm:items-end">
      {avisos.map((a) => {
        const Icono = ICONOS[a.tono]
        return (
          <button
            key={a.id}
            onClick={() => cerrarAviso(a.id)}
            className={cn(
              'pointer-events-auto flex w-full max-w-sm items-center gap-3 rounded-2xl px-4 py-3.5 text-left',
              'bg-piedra-900 text-piedra-50 sombra-flotante anim-aparecer dark:bg-piedra-800',
            )}
          >
            <Icono className={cn('size-5 shrink-0', TONOS[a.tono])} />
            <span className="text-sm font-medium">{a.texto}</span>
          </button>
        )
      })}
    </div>,
    document.body,
  )
}
